export default __webpack_public_path__ + "static/media/more-about-jumps.3db5b296.md";